namespace advisorop.components.common {

    class SearchPPAccountSecuritySymbolController {
        onSecuritySymbolSelected: any;
        selectedPPSecuritySymbol: domains.IPPSecurityDetail;
        label: string;
        labelColWidth: number = 2;
        clearAfterSelect: string = "true";
        user: domains.identity.IUser;
        currentAdvisor: domains.IAdvisor;

        static $inject = ["advisorService", "identityService"];
        constructor(public advisorService: services.AdvisorService, private identityService: services.IdentityService) {
        }

        $onInit(): void {
            //this.noResults = true;
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.currentAdvisor = this.user.advisor;
            })
         
        };

        $routerOnActivate(next, previous) {
        };


        selectedSymbol: domains.IPPSecurityDetail;
      
        search(searchTerm: string): ng.IPromise<{}> {
            return this.advisorService.searchBOSecurities(searchTerm).then((response) => {

                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            var symbol: domains.IPPSecurityDetail = {};
            angular.copy(this.selectedSymbol, symbol);


            //console.log("Selected symbol");
            //console.log(this.selectedSymbol);

            //clear only if clear property is set
            if (this.clearAfterSelect === "true")
                this.resetSearch();
            this.onSecuritySymbolSelected({ symbol: symbol });
        };

        resetSearch(): void {
           // this.selectedAdvisor = null;
            //this.advisor = null;
            //this.isAdvisorFormVisible = false;
        };

        advisorCreated(advisor: domains.IAdvisor): void {
            var adv: domains.IAdvisor = {};
            angular.copy(advisor, adv);
            this.resetSearch();
           // this.onAdvisorSelected({ advisor: adv });
        };
    }



    class SearchPPAccountSecuritySymbol implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onSecuritySymbolSelected: "&",
                selectedSymbol: "=",
                advisor: "@",
                label: "@",
                labelColWidth: "@",
                clearAfterSelect: "@"
            };
            this.controller = SearchPPAccountSecuritySymbolController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/search-pp-account-security-symbol.html';
        }
    }
    angular.module(Constants.APP).component("searchPpAccountSecuritySymbol", new SearchPPAccountSecuritySymbol());


}